import qs from 'qs';

// Shared router prefix segment for devices routes.
export const DEVICES_ROUTE_PREFIX = '/devices';

// Router basename shared with src/index.js — derive from window.MAW.basePath
export const getRouterBasename = () => {
  const { basePath = '' } = window.MAW || {};
  return `${basePath}${DEVICES_ROUTE_PREFIX}`;
};
export const HOME = '/';

export const RETURNS = '/returns';
export const RETURNS_DETAIL = '/returns/:id';

export const ACCOUNT_SWITCHER = '/select-account';

export const SWAPS = '/equipment-update';
export const SWAPS_DETAIL = '/equipment-update/:id';

export const SWAPS_NEW = '/equipment-update/new';
export const SWAPS_NEW_REVIEW = '/equipment-update/new/review';
export const SWAPS_NEW_CONFIRMATION = '/equipment-update/new/confirmation';
export const SWAPS_NEW_ERROR = 'SWAPS_NEW_ERROR'; // tracking only
export const SWAPS_NEW_INELIGIBLE = 'SWAPS_NEW_INELIGIBLE'; // tracking only

export const ERROR = '/error';

// Helper method to preserve/manage query params as the user navigates through the app,
// mainly used for the `sa` and `continueUrl` params related to selecting an account.
export const withQuery = (path, params = {}) => {
  if (Object.keys(params).length) {
    // Split path from any existing query string, merge with new params, and reconstruct
    const [pathname, existingSearch] = path.split('?');
    const merged = { ...qs.parse(existingSearch || ''), ...params };
    return `${pathname}?${qs.stringify(merged)}`;
  }

  // If no params were passed, maintain the existing query string
  return path + window.location.search;
};

export const RETURNS_HOME = '/returns';
export const RETURNS_LABEL = '/returns/label/:id';
export const RETURNS_SELECT_DEVICE = '/returns/new';
export const RETURNS_SELECT_REASON = '/returns/new/return-reason';
export const RETURNS_RETURN_METHODS = '/returns/new/return-method';
export const RETURNS_CONFIRMATION_XFINITY = '/returns/new/confirmation/xfinityStore';
export const RETURNS_CONFIRMATION_ID = '/returns/new/confirmation/:id';
export const RETURNS_ORDER_STATUS = '/returns/status';
export const RETURNS_ORDER_DETAIL = '/returns/status/:id';
export const RETURNS_DOWNTIME = '/returns/offline';

export const subst = (route, map) => (
  route
    .replace(/:([_a-zA-Z][_0-9a-zA-z])/, (_, name) => (
      map[name] || ''
    ))
    .replace(/\/{2+}/g, '/')
    .replace(/\/$/, '')
);
